export type PrizmZoneEvent = {
  time: number;
  event: UIEvent;
};
